/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Button, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import 'react-phone-input-2/lib/style.css';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';

// import services
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import Message from '../general/Message';
import GeneralNavbar from '../general/GeneralNavbar';
import Footer from '../general/Footer';
import BecomeProviderImg from '../../assets/becomeProvider.svg';
import WorkFromYourComfortImg from '../../assets/workFromYourComfort.svg';
import DevelopASideIncomeImg from '../../assets/developASideIncome.svg';

const ProviderLandingScreen = props => {

    // contexts
    const { theme, fontFamily, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [isLoading, setIsLoading] = useState(false);

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // handle functions

    // function's return
    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            <ErrorBoundary errorAt="At Provider ProviderLandingScreen GeneralNavbar">
                <GeneralNavbar history={props.history} />
            </ErrorBoundary>

            <div className="p-3">
                <h1 className="mx-auto text-center" id="counsellor-landing-heading" style={{ fontSize: "2rem" }}>Begin Providing Counselling Services</h1>

                <div className="row p-3">
                    <img id="counsellor-landing-img" className="col-md-6 col-12" src={WorkFromYourComfortImg} alt="Work from your comfort" />

                    <div className="col-md-6 col-12 my-auto">
                        <h2 id="counsellor-landing-main-text" style={{ fontSize: "1.5rem" }}>Work from your comfort</h2>
                        <p style={{ fontSize: "1.5rem" }}>
                            <ul>
                                <li id="counsellor-landing-p1">Provide your services from the comfort of your home.</li>
                                <li id="counsellor-landing-p2">Choose flexible timings to provide services.</li>
                                <li id="counsellor-landing-p3">Set your own price for your services.</li>
                                {/* <li id="counsellor-landing-p4">Work as Individual and/or with Counselling Organisations.</li> */}
                            </ul>
                        </p>
                    </div>
                </div>

                <div className='mt-5 mb-3 text-center'>
                    <Button id="start-counselling" style={theme.buttonRounded} onClick={() => props.history.push('/counsellor/signup-step1')}>Continue</Button>
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default ProviderLandingScreen;



